import { Component, useState, useEffect, useRef } from 'react';
import { isMobile } from 'react-device-detect';
import {
  YMaps,
  Map,
  Placemark,
  ZoomControl,
  FullscreenControl,
  GeolocationControl,
  withYMaps
} from 'react-yandex-maps';

class TemplateProvider extends Component {
  constructor() {
    super();

    this.state = { template: null };
  }

  componentDidMount() {
    const { ymaps } = this.props;

    this.setState({
      template: ymaps.templateLayoutFactory.createClass(
        `<div class="point single">
          <svg xmlns="http://www.w3.org/2000/svg" width="60" height="68" viewBox="0 0 60 68" fill="none">
            <path d="M30.51 56.523C30.5041 56.6516 30.4488 56.7729 30.3557 56.8618C30.2625 56.9506 30.1387 57.0001 30.01 57C29.72 57 29.5 56.79 29.49 56.523C29.345 53.355 27.734 51.306 24.658 50.376C14.53 47.968 7 38.863 7 28C7 15.297 17.297 5 30 5C42.703 5 53 15.297 53 28C53 38.863 45.47 47.968 35.342 50.376C32.266 51.306 30.655 53.356 30.512 56.523H30.51Z" fill="currentColor"/>
            <path d="M30 68C27.79 68 26 66.21 26 64C26 61.79 27.79 60 30 60C32.21 60 34 61.79 34 64C34 66.21 32.21 68 30 68Z" fill="white"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M30 66C30.2664 66.006 30.5312 65.9588 30.779 65.861C31.0269 65.7633 31.2527 65.617 31.4432 65.4308C31.6337 65.2446 31.7851 65.0222 31.8885 64.7766C31.9919 64.5311 32.0452 64.2674 32.0452 64.001C32.0453 63.7346 31.9921 63.4708 31.8889 63.2253C31.7856 62.9797 31.6343 62.7572 31.4439 62.5709C31.2535 62.3846 31.0277 62.2382 30.78 62.1403C30.5322 62.0425 30.2674 61.9951 30.001 62.001C29.4784 62.0125 28.9812 62.2282 28.6156 62.6018C28.2501 62.9754 28.0454 63.4773 28.0452 64C28.0451 64.5227 28.2496 65.0246 28.6149 65.3984C28.9803 65.7722 29.4775 65.9882 30 66Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M32.3917 16.9019C31.0277 15.6994 28.9723 15.6994 27.6083 16.9019L18.4028 25.018C17.9074 25.4547 17.8628 26.207 18.3031 26.6983C18.7434 27.1895 19.5019 27.2338 19.9972 26.7971L20.4 26.4421V33.1272C20.4 34.1823 20.3999 35.0914 20.4986 35.8195C20.6043 36.5997 20.8428 37.3476 21.4544 37.9542C22.066 38.5608 22.82 38.7973 23.6067 38.9023C24.3407 39.0001 25.2572 39 26.321 39H33.6789C34.7427 39 35.6593 39.0001 36.3933 38.9023C37.1799 38.7973 37.934 38.5608 38.5455 37.9542C39.1572 37.3476 39.3956 36.5997 39.5015 35.8195C39.6001 35.0914 39.6001 34.1823 39.6 33.1273V26.4421L40.0027 26.7971C40.4981 27.2338 41.2566 27.1895 41.6969 26.6983C42.1371 26.207 42.0926 25.4547 41.5973 25.018L32.3917 16.9019ZM30 31.8587C29.3372 31.8587 28.8 32.3915 28.8 33.0489V35.4293C28.8 36.0867 28.2628 36.6196 27.6 36.6196C26.9373 36.6196 26.4 36.0867 26.4 35.4293V33.0489C26.4 31.0768 28.0117 29.4782 30 29.4782C31.9883 29.4782 33.6 31.0768 33.6 33.0489V35.4293C33.6 36.0867 33.0627 36.6196 32.4 36.6196C31.7372 36.6196 31.2 36.0867 31.2 35.4293V33.0489C31.2 32.3915 30.6627 31.8587 30 31.8587Z" fill="white"/>
          </svg>
        </div>`
      )
    });
  }

  render() {
    const { children } = this.props;
    const { template } = this.state;

    return children({ template });
  }
}
const ConnectedTemplateProvider = withYMaps(TemplateProvider, true, ['templateLayoutFactory']);

const ObjectMap = ({ point }) => {
  const [canDrag, setCanDrag] = useState(true);
  const mapEl = useRef();

  useEffect(() => {
    if (isMobile) {
      setCanDrag(false);
    }
  }, []);

  return (
    <YMaps query={{ apikey: process.env.NEXT_PUBLIC_YANDEX_KEY }}>
      <ConnectedTemplateProvider>
        {({ template }) => (
          <Map
            style={{ width: '100%', height: '100%' }}
            defaultState={{
              center: point,
              zoom: 17,
              controls: [],
              behaviors: [canDrag && 'drag', 'dblClickZoom', 'multiTouch']
            }}
            defaultOptions={{
              maxZoom: 20,
              autoFitToViewport: 'always',
              yandexMapDisablePoiInteractivity: true,
              suppressObsoleteBrowserNotifier: true,
              suppressMapOpenBlock: true
            }}
            instanceRef={(ref) => {
              if (ref) {
                mapEl.current = ref;
              }
            }}
          >
            {!isMobile && (
              <ZoomControl
                options={{
                  position: { right: '12px', top: '123px' },
                  size: 'small'
                }}
              />
            )}
            <FullscreenControl
              options={{
                position: { right: '12px', top: '12px' }
              }}
              onClick={() => {
                if (!mapEl.current || !isMobile) return;

                const isFullscreen = !mapEl.current.container.isFullscreen();

                if (isFullscreen) mapEl.current.behaviors.enable('drag');
                else mapEl.current.behaviors.disable('drag');
              }}
            />
            <GeolocationControl
              options={{
                position: { left: '12px', top: '12px' }
              }}
            />
            <Placemark
              geometry={point}
              options={{
                iconLayout: template,
                iconOffset: [0, -65],
                iconShape: {
                  type: 'Rectangle',
                  coordinates: [
                    [-25, 5],
                    [22, 68]
                  ]
                }
              }}
            />
          </Map>
        )}
      </ConnectedTemplateProvider>
    </YMaps>
  );
};

export default ObjectMap;
